import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center w-full h-64">
      <div className="w-12 h-12 animate-spin">
        <svg
          className="w-full h-full"
          viewBox="0 0 50 50"
        >
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="#facc15"
            strokeWidth="5"
            strokeLinecap="round"
            strokeDasharray="120"
            strokeDashoffset="30"
          />
        </svg>
      </div>
    </div>
  );
};

export default LoadingSpinner;
